import {
  BandwidthAction,
  LOAD_WEBSITE_BANDWIDTH,
  LOAD_WEBSITE_BANDWIDTH_FAIL,
  LOAD_WEBSITE_BANDWIDTH_SUCCESS,
  LoadWebsiteBandwidth,
  LoadWebsiteBandwidthFail
} from '../actions/bandwidth.action';
import {BandwidthData} from "../../websites/website/booster/mappers/cloudflare/bandwidth";
import {LoadWebsiteBandwidthSuccess} from "../actions";

export interface IBandwidthEntityState {
  bandwidthData: BandwidthData;
  loading: boolean;
  loaded: boolean;
}

export interface IBandwidthState {
  [websiteId: number]: IBandwidthEntityState;
}

export const initialState: IBandwidthState = {};


export function reducer(state: IBandwidthState = initialState, action: BandwidthAction): IBandwidthState {
  let payload: any;

  switch (action.type) {

    case LOAD_WEBSITE_BANDWIDTH:
      payload = (<LoadWebsiteBandwidth>action).payload;

      return {
        ...state,
        [payload.websiteId]: {
          ...state[payload.websiteId],
          loading: true,
          loaded: false,
        }
      };

    case LOAD_WEBSITE_BANDWIDTH_SUCCESS:
      payload = (<LoadWebsiteBandwidthSuccess>action).payload;
      return {
        ...state,
        [payload.websiteId]: {
          bandwidthData: payload.entities,
          loading: false,
          loaded: true,
        }
      };

    case LOAD_WEBSITE_BANDWIDTH_FAIL:
      payload = (<LoadWebsiteBandwidthFail>action).payload;

      return {
        ...state,
        [payload.websiteId]: {
          ...state[payload.websiteId],
          loading: false,
          loaded: true,
        }
      };

  }

  return state;
}
